import React from 'react';
import { Banner, Gutter } from '@common/components';
import { ShiftPreviewCard } from './_shift-preview-card';
import type { PreviewDataType } from './_transform-simulation-data-service';

export function WorkloadPreview({ data }: { data: PreviewDataType }) {
  const changeSummary = formatChangeSummary(
    data.createdOpenings,
    data.closedOpenings,
    data.totalShifts
  );

  return (
    <>
      <Banner type="info" showIcon>
        These shifts are generated based on your organization&apos;s Shift
        Times. {changeSummary}
      </Banner>
      <Gutter size="md" direction="top">
        {data.shiftGroups.map((group) => (
          <ShiftPreviewCard key={group.key} group={group} />
        ))}
      </Gutter>
    </>
  );
}

function formatChangeSummary(
  created: number,
  closed: number,
  totalShifts: number
): string {
  if (created === 0 && closed === 0) {
    return 'No shifts will be added, updated, or removed.';
  }

  const nounOpening = created + closed === 1 ? 'opening' : 'openings';
  const nounShift = totalShifts === 1 ? 'shift' : 'shifts';

  if (created > 0 && closed > 0) {
    return `This will create ${created} ${nounOpening} and remove ${closed} across ${totalShifts} ${nounShift}.`;
  }

  const change = created > 0 ? `create ${created}` : `remove ${closed}`;

  return `This will ${change} ${nounOpening} across ${totalShifts} ${nounShift}.`;
}
